import { componentFactory } from '../../../fc-core/src/lib';
import CrossLine from './crossline';
import CrosslineManagerBand from './crossline-manager-band-category-axis';
var CANVAS = 'canvas',
    CHARTAPI = 'chartAPI',
    CROSSLINEMANAGER = 'crossline-manager',
    chartExclusionList = {
  dragnode: !0,
  hlineargauge: !0,
  column3d: !0,
  mscolumn3d: !0,
  bar3d: !0,
  pareto3d: !0,
  msbar3d: !0,
  stackedcolumn3d: !0,
  stackedbar3d: !0,
  mscombi3d: !0,
  mscolumnline3d: !0,
  stackedcolumn3dline: !0,
  mscolumn3dlinedy: !0,
  stackedcolumn3dlinedy: !0,
  realtimearea: !0,
  realtimecolumn: !0,
  realtimeline: !0,
  realtimestackedarea: !0,
  realtimestackedcolumn: !0,
  angulargauge: !0,
  realtimelinedy: !0,
  kagi: !0,
  scrollcolumn2d: !0,
  scrollline2d: !0,
  scrollarea2d: !0,
  scrollstackedcolumn2d: !0,
  scrollcombi2d: !0,
  scrollcombidy2d: !0,
  scrollcombi2dspline: !0,
  treemap: !0,
  heatmap: !0,
  boxandwhisker2d: !0,
  scatter: !0,
  timeseries: !0,
  bubble: !0,
  errorscatter: !0,
  sparkwinloss: !0,
  zoomscatter: !0,
  zoomline: !0,
  zoomlinedy: !0
};
export default {
  extension: function extension(a) {
    a.addEventListener('preconfigure', function (a) {
      if (a.sender.getType() === CHARTAPI) {
        var b = a.sender,
            c = b.getFromEnv('chartInstance');

        c.drawCrossline = function (a) {
          c.drawConsolidatedToolTip(a), b.iterateComponents(function (b) {
            b.getType() === CROSSLINEMANAGER && (a === void 0 ? b.hide() : b.show({
              value: a
            }));
          });
        };
      }
    }), a.addEventListener('instantiated', function (a) {
      if (a.sender.getName() === CANVAS) {
        var b,
            c,
            d = a.sender;
        d.registerFactory('crossLineManager', function () {
          var e = a.sender.getFromEnv('chart'),
              f = e && e.getName();
          f && !chartExclusionList[f.toLowerCase()] && (componentFactory(d, CrosslineManagerBand, 'crosslineManagerBand'), b = d.getChildren('crosslineManagerBand')[0], c = b._handlerAPI, b.configure(), componentFactory(b, CrossLine, 'crossline'), b.addExtEventListener('fc-mouseover', c.onhover, d), b.addExtEventListener('fc-mousemove', c.onhover, d), b.addExtEventListener('fc-mouseout', c.onhoverout, d));
        });
      }
    });
  },
  name: 'crossline-manager',
  type: 'extension',
  requiresFusionCharts: !0
};